import { render, staticRenderFns } from "./DefaultPage.htm?vue&type=template&id=53af4b25&scoped=true&external"
import script from "./DefaultPage.js?vue&type=script&lang=js&external"
export * from "./DefaultPage.js?vue&type=script&lang=js&external"
import style0 from "./DefaultPage.scss?vue&type=style&index=0&id=53af4b25&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53af4b25",
  null
  
)

export default component.exports